import React, { forwardRef,useRef, useState } from "react";
import github from "../../images/github.png";
import linkedin from "../../images/linkedin.png";

const Footer = forwardRef((props, ref) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });  const footerSectionRef = useRef(null); // Create a ref for the About section

  const [msg, setMsg] = useState('');
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name.toLowerCase()]: value
    });
  };const scrollToAbout = () => {
    if (footerSectionRef.current) {
      footerSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const validateForm = () => {
    let valid = true;
    let errors = {};

    if (/[^a-zA-Z0-9\s]/.test(formData.name)) {
      valid = false;
      errors.name = 'Name should not contain special characters.';
    }
    setErrors(errors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return; // If validation fails, do not proceed with form submission
    }

    const scriptURL = 'https://script.google.com/macros/s/AKfycbyDzUhlIKnjtIMQy_fztnaKSd1fDeOskbNaA0gbdPF8K-lWpthzrOw5F9gY3GqWiYBFtQ/exec'; // Replace with your script URL

    try {
      const response = await fetch(scriptURL, {
        method: 'POST',
        body: new URLSearchParams({
          name: formData.name,
          email: formData.email,
          message: formData.message
        })
      });
      if (response.ok) {
        setMsg('Form submitted successfully!');
        setFormData({ name: '', email: '', message: '' });
        setErrors({}); // Clear errors on successful submission
      } else {
        setMsg('Form submission failed.');
      }
    } catch (error) {
      setMsg('Form submission failed.');
    }
  };

  return (
    <section id="contact" ref={ref} className="grid md:grid-cols-2 my-1 py-24 gap-4 relative px-4">
      <div className="bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary-900 to-transparent rounded-full h-80 w-80 z-0 blur-lg  absolute top-0.6 -left-4 transform -translate-x-1/2 -translate-1/2"></div>
      <div className="z-10">
        <h5 className="text-xl font-bold text-white px-4">Let&apos;s Connect</h5>
        <p className="text-[#ADB7BE] mb-4 max-w-md px-4">
          I&apos;m currently looking for new opportunities, my inbox is always
          open. Whether you have a question or just want to say hi, I&apos;ll
          try my best to get back to you!
        </p>
        <div className="socials flex flex-row gap-1 px-4">
          <a href="https://github.com" target="_blank" rel="noopener noreferrer">
            <img src={github} alt="Github Icon" className="w-16 h-16" />
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
            <img src={linkedin} alt="Linkedin Icon" className="w-16 h-16" />
          </a>
        </div>
      </div>
      <div>
        <form className="flex flex-col px-4" onSubmit={handleSubmit}>
          <div className="mb-6">
            <label htmlFor="name" className=" text-white block text-sm mb-2 font-medium">
              Your name
            </label>
            <input
              name="name"
              type="text"
              id="name"
              required
              value={formData.name}
              onChange={handleChange}
              className="bg-[#18191E] border border-[#33353F] placeholder-[#9CA2A9] text-gray-100 text-sm rounded-lg block w-full p-2.5"
              placeholder="Your name"
            />
            {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
          </div>
          <div className="mb-6 ">
            <label htmlFor="email" className="text-white block mb-2 text-sm font-medium">
              Your email
            </label>
            <input
              name="email"
              type="email"
              id="email"
              required
              value={formData.email}
              onChange={handleChange}
              className="bg-[#18191E] border border-[#33353F] placeholder-[#9CA2A9] text-gray-100 text-sm rounded-lg block w-full p-2.5"
              placeholder="@gmail.com"
            />
          </div>
          <div className="mb-6">
            <label htmlFor="message" className="text-white block text-sm mb-2 font-medium">
              Message
            </label>
            <textarea
              name="message"
              id="message"
              value={formData.message}
              onChange={handleChange}
              className="bg-[#18191E] border border-[#33353F] placeholder-[#9CA2A9] text-gray-100 text-sm rounded-lg block w-full p-2.5"
              placeholder="Let's talk about..."
            />
          </div>
          <button
            type="submit"
            className="px-4 bg-primary-800 hover:bg-primary-600 text-white font-medium py-2.5 px-5 rounded-lg w-full"
          >
            Send Message
          </button>
        </form>
        {msg && <p className="text-green-500 text-sm mt-2 px-4">{msg}</p>}
      </div>
    </section>
  );
});

export default Footer;
